module.exports = __webpack_public_path__ + "static/media/3.37663699.jpg";